import classNames from 'classnames';
import { useEffect, useState } from 'react';

import {
    gdprAddEventListener,
    GdprCookiePurposes,
    gdprRemoveEventListener,
    hasAcceptedGdprPurpose,
} from '../../../../utility/gdpr';
import useHtmlScriptParser from '../../../common/hooks/useHtmlScriptParser';
import styles from './Footer.module.scss';

const FooterLogos = (props: Pick<FrontendFooter, 'logos'>) => {
    const [consentPurposeAccepted, setConsentPurposeAccepted] = useState(false);

    // script must have text/javascript to fire onloads, otherwise its treated as plain text
    const scriptsContainerRef = useHtmlScriptParser(
        '<script type="text/javascript" src="https://cert.tryggehandel.net/js/script.js?id=a45e1529-7d52-45a5-8e2f-c79cddb2f92b" />',
        consentPurposeAccepted,
    );

    useEffect(() => {
        const checkPurpose = () => {
            setConsentPurposeAccepted(hasAcceptedGdprPurpose(GdprCookiePurposes.Marketing));
        };

        gdprAddEventListener('consent', checkPurpose);

        // in case cmp has already loaded content, sync set the purpose
        checkPurpose();

        return () => {
            gdprRemoveEventListener('consent', checkPurpose);
        };
    }, []);

    return (
        <div className="u-textCenter">
            <h2 className={styles.h2}>Handla på coop.se</h2>
            <div className={styles.FooterShopOnline}>
                {props.logos.map((logo) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div
                        className={styles.FooterShopOnlineItem}
                        key={`${logo.url}_${logo.imageAltText}_${logo.imageHeight}_${logo.imageSrc}`}
                    >
                        {logo.url ? (
                            <a href={logo.url} target="_blank" rel="noreferrer">
                                <img
                                    height={logo.imageHeight}
                                    alt={logo.imageAltText}
                                    src={logo.imageSrc}
                                    loading="lazy"
                                />
                            </a>
                        ) : (
                            <img
                                height={logo.imageHeight}
                                alt={logo.imageAltText}
                                src={logo.imageSrc}
                                loading="lazy"
                            />
                        )}
                    </div>
                ))}

                <div
                    className={classNames(
                        styles.FooterShopOnlineItem,
                        'teh-certificate', // this class is important since Trygghandel script is looking for it
                    )}
                />
                <div style={{ display: 'none' }} ref={scriptsContainerRef} />
            </div>
        </div>
    );
};

export default FooterLogos;
